import manifest from '../style.manifest.json';

export function downloadSelectorsTxt() {
  const entries = manifest.selectors || [];

  const grouped = entries.reduce((acc, { section = 'General', selector, description }) => {
    if (!acc[section]) acc[section] = [];
    acc[section].push({ selector, description });
    return acc;
  }, {});

  const lines = [];
  Object.entries(grouped).forEach(([section, items]) => {
    lines.push(`## ${section}`, '');
    items.forEach(({ selector, description }) => {
      lines.push(`${selector} — ${description}`);
    });
    lines.push('');
  });

  const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = 'selectors.txt';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
